import React, { CSSProperties, useEffect, useState } from "react";
import { PuffLoader } from "react-spinners";
import styles from "./loading.spinner.module.scss";
import MascotLogo from "../../../assets/theme/images/mascot-logo.svg"
interface LoadingSpinnerProps {
  loading?: boolean;
}

const override: CSSProperties = {
  display: "block",
  margin: " 0 auto",
};
const colors = [
  "#8B00FF",
  "#4B0082",
  "#0000FF",
  "#008000",
  "#FFFF00",
  "#FFA500",
  "#FF0000",
];

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ loading }) => {
  const [colorIndex, setColorIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setColorIndex((prevIndex) => (prevIndex + 1) % colors.length);
    }, 500); // Change color every 500ms

    return () => clearInterval(interval);
  }, []);

  return (
    <div className={styles.spinnerOverlayWrapper}>
      <div className={styles.spinnerContainer}>
        <PuffLoader
          cssOverride={override}
          size={100}
          color={colors[colorIndex]}
          loading={loading}
        />
        <div className={styles.mascotLogo}>
          <img src={MascotLogo} alt="Mascot Logo" />
        </div>
      </div>
    </div>
  );
};

export default LoadingSpinner;
